// App-root Motion providers, shared by every Liquid Spirit web app.
//
// Mount this once near the top of the provider tree. It:
//   - honours the OS reduced-motion preference app-wide (MotionConfig), so
//     individual components never have to branch on it;
//   - runs LazyMotion in `strict` mode, which means components MUST animate via
//     `m.*` (imported from this package) rather than `motion.*` — a stray
//     `motion.div` throws in dev, keeping the lazy-loading discipline intact;
//   - loads the heavyweight animation engine (domMax) as its own async chunk on
//     first paint, keeping it out of the entry bundle.
import React from 'react';
import { LazyMotion, MotionConfig } from 'motion/react';

const loadFeatures = () => import('./motionFeatures.js').then((module) => module.default);

export default function MotionRoot({ children }) {
  return (
    <MotionConfig reducedMotion="user">
      <LazyMotion features={loadFeatures} strict>
        {children}
      </LazyMotion>
    </MotionConfig>
  );
}
